export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001/v1',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  appName: import.meta.env.VITE_APP_NAME ?? 'Organiza.AI',
  inboundEmailDomain:
    import.meta.env.VITE_INBOUND_EMAIL_DOMAIN ?? 'inbox-mednotas.contrast-ai.com.br',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
} as const;
